import { extent } from 'd3-array';
import { scaleLinear } from 'd3-scale';
import { useMemo } from 'react';

function useHorizontalTicksAndScale({
  maxWidth,
  allNumbers,
  labelFormatter,
  isStacked,
  stackedMin,
  stackedMax
}) {
  const xScale = useMemo(() => {
    const areAllZero = !allNumbers.some(num => num != null && num !== 0);
    const domainValues = [0, ...allNumbers];
    if (areAllZero) {
      domainValues.push(1);
    }
    return scaleLinear().range([0, maxWidth]).domain(extent(domainValues, num => num)).nice();
  }, [maxWidth, allNumbers]);
  const ticks = useMemo(() => {
    return xScale.ticks();
  }, [xScale]);
  const xScaleStacked = useMemo(() => {
    if (!isStacked) {
      return null;
    }
    const xScale = scaleLinear().range([0, maxWidth]).domain([stackedMin, stackedMax]).nice();
    return xScale;
  }, [isStacked, maxWidth, stackedMin, stackedMax]);
  const ticksStacked = useMemo(() => {
    if (!isStacked || !xScaleStacked) {
      return [];
    }
    return xScaleStacked.ticks();
  }, [isStacked, xScaleStacked]);
  const finalTicks = isStacked ? ticksStacked : ticks;
  return {
    ticks: finalTicks,
    xScale: isStacked ? xScaleStacked : xScale,
    ticksFormatted: finalTicks.map(tick => `${labelFormatter(tick)}`)
  };
}

export { useHorizontalTicksAndScale };
